import { startOfMonth } from "date-fns";

export const title = "Sales Item";

export const tableWidth = "w-[53.5rem]";

export const paramSettings = [
  {
    name: "dari",
    field: "data_sales.transaction_date",
    type: "date",
    format: "yyyy-MM-dd 00:00:00",
    operator: ">=",
    default: startOfMonth(new Date()),
    nullable: false,
  },
  {
    name: "sampai",
    field: "data_sales.transaction_date",
    type: "date",
    format: "yyyy-MM-dd 23:59:59",
    operator: "<=",
    default: new Date(),
    nullable: false,
  },
  {
    name: "data_product",
    default: [],
  },
];

export const generateDefaultReportParams = () => {
  const defaultParam = {};

  for (let param of paramSettings) {
    if (param.name === "dari") {
      defaultParam[param.name] = startOfMonth(new Date());
    } else if (param.name === "sampai") {
      defaultParam[param.name] = new Date();
    } else {
      defaultParam[param.name] = param.default;
    }
  }

  return defaultParam;
};

export const groupSetting = {
  name: "Category Name",
  field: "category_name",
  data_field: undefined,
};

export const columnSettings = [
  {
    name: "NO",
    field: "no",
    type: "number",
    width: "w-[3.5rem]",
    layout: "col-start-center",
  },
  {
    name: "PRODUCT NAME",
    field: "product_name",
    type: "string",
    width: "w-[17rem]",
    layout: "col-start-start",
  },
  {
    name: "CATEGORY NAME",
    field: "category_name",
    type: "string",
    width: "w-[12rem]",
    layout: "col-start-start",
  },
  {
    name: "QTY",
    field: "total_quantity",
    type: "number",
    width: "w-[4rem]",
    layout: "col-start-end",
  },
  {
    name: "@ PRICE",
    field: "product_price",
    type: "number",
    width: "w-[7rem]",
    layout: "col-start-end",
  },
  {
    name: "DISCOUNT",
    field: "discount",
    type: "number",
    width: "w-[6rem]",
    layout: "col-start-end",
  },
  {
    name: "SUBTOTAL",
    field: "sub_total",
    type: "number",
    width: "w-[8rem]",
    layout: "col-start-end",
  },
  {
    name: "GRANDTOTAL",
    field: "grand_total",
    type: "number",
    width: "w-[8rem]",
    layout: "col-start-end",
  },
];
